import moment from 'moment';

import {
  PATIENT_OPTIONS,
  PAYER_OPTIONS,
  PROVIDER_OPTIONS
} from 'components/shared/Filters/lib/filterOptions';
import { filterOptions } from 'components/shared/Filters/lib/helpers';

const COMPLETED_TXN_STATUSES = [
  { label: 'COMPLETED', value: 'completed' },
  { label: 'APPROVAL', value: 'APPROVAL' },
  { label: 'PARTIALLY REFUNDED', value: 'partially_refunded' }
];

const REPORT_STATUS_OPTIONS = [
  { label: 'Completed', value: 'completed' },
  { label: 'Voided', value: 'voided' },
  { label: 'Refunded', value: 'refunded' },
  { label: 'Partially Refunded', value: 'partially_refunded' },
  { label: 'Canceled', value: 'canceled' }
];

const REPORT_TRANSACTION_TYPE_OPTIONS = [
  { label: 'Credit Card', value: 'card' },
  { label: 'Cash', value: 'cash' },
  { label: 'Check', value: 'check' },
  { label: 'Outside Financing', value: 'outside_financing' },
  { label: 'Insurance Payment', value: 'insurance' }
];

const allowed_operators = ['is', 'is not', 'is any of'];

const GENERAL_FILTERS = {
  date: {
    title: 'Report period',
    icon: 'calendar-mono',
    type: 'date-range',
    formula: 'is',
    values: {
      id: 'today',
      startDate: moment().format('MM/DD/YYYY'),
      endDate: moment().format('MM/DD/YYYY')
    },
    default: true
  },
  amount: {
    type: 'range',
    values: null,
    title: 'Amount',
    placeholder: 'Search amount',
    icon: 'dollar-circle-mono'
  }
};

const getStatusFilter = (options) => {
  return {
    values: null,
    title: 'Status',
    icon: 'status-mono',
    allowed_operators,
    queryFn: (_, data) => filterOptions(data.filters.searchTerm, options)
  };
};

const PAYMENT_REPORT_FILTERS = {
  payments: {
    ...GENERAL_FILTERS,
    patient: { ...PATIENT_OPTIONS, allowed_operators },
    payer: { ...PAYER_OPTIONS, allowed_operators },
    provider: { ...PROVIDER_OPTIONS, allowed_operators },
    status: {
      ...getStatusFilter(REPORT_STATUS_OPTIONS),
      queryKey: 'report_statuses.options'
    },
    transaction_type: {
      values: null,
      title: 'Transaction Type',
      queryFn: (_, data) => filterOptions(data.filters.searchTerm, REPORT_TRANSACTION_TYPE_OPTIONS),
      queryKey: 'report_transaction_types.options',
      icon: 'list-unordered-mono',
      allowed_operators
    }
  },
  accountsReceivable: {
    ...GENERAL_FILTERS,
    patient: { ...PATIENT_OPTIONS, allowed_operators },
    payer: { ...PAYER_OPTIONS, allowed_operators },
    provider: { ...PROVIDER_OPTIONS, allowed_operators }
  },
  avgPaymentComparisonByProcedure: {
    ...GENERAL_FILTERS
  },
  paymentByProcedureAndPayer: {
    ...GENERAL_FILTERS,
    payer: { ...PAYER_OPTIONS, allowed_operators }
  },
  paymentsAdjustments: {
    ...GENERAL_FILTERS
  }
};

const FINANCIAL_REPORT_FILTERS = {
  product_sale: {
    ...GENERAL_FILTERS,
    patient: { ...PATIENT_OPTIONS, allowed_operators }
  },
  financial_reporting: PAYMENT_REPORT_FILTERS.payments,
  daily_batch_transaction: {
    ...GENERAL_FILTERS,
    status: {
      ...getStatusFilter(COMPLETED_TXN_STATUSES),
      queryKey: 'completed_transaction_statuses.options',
      default: true,
      formula: 'is any of',
      values: COMPLETED_TXN_STATUSES,
      allowed_operators: ['is any of']
    }
  }
};

const DEFAULT_REPORT_FILTERS = {
  ...PAYMENT_REPORT_FILTERS,
  ...FINANCIAL_REPORT_FILTERS
};

export const getDefaultReportFilters = (category, key) => {
  return DEFAULT_REPORT_FILTERS?.[key] || DEFAULT_REPORT_FILTERS?.[category] || GENERAL_FILTERS;
};
